import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TypographyProps } from "@tCooneyBrothers/MobiusOverrides/Typography";
import * as React from "react";
import { css } from "styled-components";
import InvoiceDetailsBillingAddress, {
    InvoiceDetailsBillingAddressStyles,
} from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsBillingAddress";
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import InvoiceDetailsShippingAddress, {
    InvoiceDetailsShippingAddressStyles,
} from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsShippingAddress";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { InvoiceDetailsLineCardStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";

const mapStateToProps = (state: ApplicationState) => ({
    language: state.context.session.language,
    enableVat: getSettingsCollection(state).productSettings.enableVat,
});

interface OwnProps {
    printRef?: React.RefObject<HTMLDivElement>;
}

export interface InvoiceHistoryPrintStyles {
    container?: GridContainerProps;
    invoiceLogo?: InjectableCss;
    invoicelogoGridFirst?: GridItemProps;
    invoicelogoGridSecond?: GridItemProps;
    invoiceContainer?: InjectableCss;
    invoiceWrapper?: InjectableCss;
    invoiceDate?: GridItemProps;
    invoiceNumber?: GridItemProps;
    invoiceText?: TypographyProps;
    invoiceNumberGridItem?: GridItemProps;
    invoiceTableSecondRow?: InjectableCss;
    invoiceDateInfoGridItem?: GridItemProps;
    invoiceInfoWrapperFirstRow?: InjectableCss;
    invoiceDateData?: GridItemProps;
    invoiceNumberData?: GridItemProps;
    billingShippingConatiner?: GridItemProps;
    billingAddressGridItem?: GridItemProps;
    shippingAddressGridItem?: GridItemProps;
    billingAddressStyle?: InvoiceDetailsBillingAddressStyles;
    shippingAddressStyle?: InvoiceDetailsShippingAddressStyles;
    customerNumberGridItem?: GridItemProps;
    customerOrderNumberGridItem?: GridItemProps;
    orderByGridItem?: GridItemProps;
    releaseNumberGridItem?: GridItemProps;
    salespersonGridItem?: GridItemProps;
    customerInfoWrapperFirstRow?: InjectableCss;
    customerInfoWrapperFirstRowFirstTable?: GridItemProps;
    customerInfoWrapperFirstRowSecondTable?: GridItemProps;
    customerInfoWrapperSecondrRow?: InjectableCss;
    customerInfoWrapperSecondrRowThirdTable?: InjectableCss;
    customerInfoGridItem?: GridItemProps;
    customerInfoGridItemThirdTable?: GridItemProps;
    invoiceThirdLineItemTable?: InjectableCss;
    description?: TypographyProps;
    writerGridItem?: GridItemProps;
    shipViaNumberGridItem?: GridItemProps;
    termsGridItem?: GridItemProps;
    shipDateGridItem?: GridItemProps;
    orderDateGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    qtyOrderedGridItem?: GridItemProps;
    qtyShippedrGridItem?: GridItemProps;
    priceGridItem?: GridItemProps;
    extPriceGridItem?: GridItemProps;
    linesItem?: GridItemProps;
    linesInnerContainer?: GridContainerProps;
    lineStyles?: InvoiceDetailsLineCardStyles;
    lineItem?: GridItemProps;
    signatureWrapper: InjectableCss;
    titleText?: TypographyProps;
    signatureContainer?: GridContainerProps;
    signatureText?: TypographyProps;
    labelGridItem?: GridItemProps;
    valueGridItem?: GridItemProps;
    subtotalLabelText?: TypographyProps;
    subtotalValueText?: TypographyProps;
    discountsLabelText?: TypographyProps;
    discountsValueText?: TypographyProps;
    shippingAndHandlingLabelText?: TypographyProps;
    shippingAndHandlingValueText?: TypographyProps;
    otherChargesLabelText?: TypographyProps;
    otherChargesValueText?: TypographyProps;
    taxLabelText?: TypographyProps;
    taxValueText?: TypographyProps;
    totalLabelText?: TypographyProps;
    totalValueText?: TypographyProps;
    subContainer?: GridContainerProps;
    alignSignature: InjectableCss;
    signatureWrapperTotal?: GridContainerProps;
    totalContainer?: InjectableCss;
    messageWrapper: InjectableCss;
    msgTotalWrapper: InjectableCss;
    messageGridItem?: GridItemProps;
    msgText1: InjectableCss;
    msgText2: InjectableCss;

    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    dataTableHead?: DataTableHeadProps;
    shipmentDateHeader?: DataTableHeaderProps;
    carrierHeader?: DataTableHeaderProps;
    shipViaHeader?: DataTableHeaderProps;
    trackingNumberHeader?: DataTableHeaderProps;
    dataTableBody?: DataTableBodyProps;
    dataTableRow?: DataTableRowProps;
    shipmentDateCell?: DataTableCellProps;
    carrierCell?: DataTableCellProps;
    shipViaCell?: DataTableCellProps;
    trackingNumberCell?: DataTableCellProps;
}

export const InvoiceHistoryPrintStyles: InvoiceHistoryPrintStyles = {
    signatureWrapper: {
        css: css`
            width: 40%;
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            padding: 10px;
            padding-left: 0;
            background: #f8f9fa;
            span {
                padding-left: 5px;
            }
        `,
    },

    alignSignature: {
        css: css`
            text-align: right;
            width: 100%;
            margin-left: auto;
        `,
    },

    messageWrapper: {
        css: css`
            width: 75%;
        `,
    },
    messageGridItem: {
        css: css`
            max-width: 75%;
            display: grid;
        `,
    },

    msgTotalWrapper: {
        css: css`
            display: flex;
            margin-top: 30px;
        `,
    },

    msgText1: {
        css: css`
            padding-top: 30px;
        `,
    },

    msgText2: {
        css: css`
            padding-top: 30px;
            font-size: 19px;
            font-weight: bold;
        `,
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const styles = InvoiceHistoryPrintStyles;

const InvoiceHistoryPrintComponent: React.FC<Props> = ({ language, enableVat, printRef }: Props) => {
    const { value: invoice } = React.useContext(InvoiceStateContext);

    console.log("invoice", invoice);

    if (!invoice) {
        return null;
    }
    if (!invoice || !invoice.invoiceLines || invoice.invoiceLines.length === 0) {
        return null;
    }

    const shipmentObj = invoice.properties.shipments === undefined ? null : JSON.parse(invoice.properties.shipments);

    return (
        <>
            <StyledWrapper className="container" {...styles.container}>
                <StyledWrapper className="invoiceContainer" {...styles.invoiceContainer}>
                    <GridItem
                        className="invoicelogoGridFirst"
                        {...styles.invoicelogoGridFirst}
                        data-test-selector="invoicePtint-Logo"
                    >
                        <LazyImage
                            className="invoiceLogo"
                            {...styles.invoiceLogo}
                            src="/UserFiles/images/invoicepage/invoicelogollc.png"
                        ></LazyImage>
                    </GridItem>
                    {/* Invoice */}
                    <GridItem className="invoicelogoGridSecond" {...styles.invoicelogoGridSecond}>
                        <GridItem
                            className="invoiceDateInfoGridItem"
                            {...styles.invoiceDateInfoGridItem}
                            data-test-selector="invoicePrint- DateNumberFields"
                        >
                            <Typography className="invoiceText" {...styles.invoiceText}>
                                {translate("INVOICE")}
                            </Typography>
                            <StyledWrapper
                                className="invoiceInfoWrapperFirstRow"
                                {...styles.invoiceInfoWrapperFirstRow}
                            >
                                <GridItem className="invoiceDate" {...styles.invoiceDate}>
                                    <Typography variant="p"> {translate("INVOICE DATE")}</Typography>
                                </GridItem>
                                <GridItem className="invoiceNumber" {...styles.invoiceNumber}>
                                    <Typography variant="p">{translate("INVOICE NUMBER")}</Typography>
                                </GridItem>
                            </StyledWrapper>
                            {/* Table Second Row */}
                            <StyledWrapper className="invoiceTableSecondRow" {...styles.invoiceTableSecondRow}>
                                <GridItem className="invoiceDateData" {...styles.invoiceDateData}>
                                    <Typography className="description" {...styles.description}>
                                        {getLocalizedDateTime({
                                            dateTime: new Date(invoice.invoiceDate),
                                            language,
                                        })}
                                    </Typography>
                                </GridItem>
                                <GridItem className="invoiceNumberData" {...styles.invoiceNumberData}>
                                    <Typography className="description" {...styles.description}>
                                        {invoice.invoiceNumber}
                                    </Typography>
                                </GridItem>
                            </StyledWrapper>
                        </GridItem>
                    </GridItem>
                </StyledWrapper>
                {/* Billing and shipping addresss Container */}
                <GridItem
                    className="billingShippingConatiner"
                    {...styles.billingShippingConatiner}
                    data-test-selector="invoicePrint-BillingShippingContainer"
                >
                    <GridItem className="billingAddressGridItem" {...styles.billingAddressGridItem}>
                        <InvoiceDetailsBillingAddress invoice={invoice} extendedStyles={styles.billingAddressStyle} />
                    </GridItem>
                    <GridItem className="shippingAddressGridItem" {...styles.shippingAddressGridItem}>
                        <InvoiceDetailsShippingAddress invoice={invoice} extendedStyles={styles.shippingAddressStyle} />
                    </GridItem>
                </GridItem>

                <StyledWrapper>
                    {/* first table first  row */}
                    <GridItem
                        className="customerInfoGridItem"
                        {...styles.customerInfoGridItem}
                        data-test-selector="invoicePrint-FirstCustomerInfoTable"
                    >
                        <StyledWrapper
                            className="customerInfoWrapperFirstRowFirstTable"
                            {...styles.customerInfoWrapperFirstRowFirstTable}
                        >
                            <GridItem className="customerNumberGridItem" {...styles.customerNumberGridItem}>
                                <Typography>{translate("CUSTOMER NUMBER")}</Typography>
                            </GridItem>
                            <GridItem className="customerOrderNumberGridItem" {...styles.customerOrderNumberGridItem}>
                                <Typography>{translate("CUSTOMER ORDER NUMBER")}</Typography>
                            </GridItem>
                            <GridItem className="orderByGridItem" {...styles.orderByGridItem}>
                                <Typography>{translate("ORDERED BY")}</Typography>
                            </GridItem>
                            <GridItem className="releaseNumberGridItem" {...styles.releaseNumberGridItem}>
                                <Typography>{translate(" RELEASE NUMBER")}</Typography>
                            </GridItem>
                            <GridItem className="salespersonGridItem" {...styles.salespersonGridItem}>
                                <Typography>{translate(" SALESPERSON")}</Typography>
                            </GridItem>
                        </StyledWrapper>
                        {/* first table  Second Row */}
                        <StyledWrapper
                            className="customerInfoWrapperSecondrRow"
                            {...styles.customerInfoWrapperSecondrRow}
                        >
                            <GridItem className="customerNumberGridItem" {...styles.customerNumberGridItem}>
                                <Typography className="description" {...styles.description}>
                                    {invoice.customerNumber}
                                </Typography>
                            </GridItem>
                            <GridItem className="customerOrderNumberGridItem" {...styles.customerOrderNumberGridItem}>
                                <Typography className="description" {...styles.description}>
                                    {invoice.customerPO}
                                </Typography>
                            </GridItem>
                            <GridItem className="orderByGridItem" {...styles.orderByGridItem}>
                                <Typography className="description" {...styles.description}>
                                    {invoice.properties?.orderedBy}
                                </Typography>
                            </GridItem>
                            <GridItem className="releaseNumberGridItem" {...styles.releaseNumberGridItem}>
                                <Typography className="description" {...styles.description}>
                                    {invoice?.invoiceLines[0]?.releaseNumber}
                                </Typography>
                            </GridItem>
                            <GridItem className="salespersonGridItem" {...styles.salespersonGridItem}>
                                <Typography className="description" {...styles.description}>
                                    {invoice.salesperson}
                                </Typography>
                            </GridItem>
                        </StyledWrapper>
                    </GridItem>
                </StyledWrapper>

                {/* Second table */}
                <StyledWrapper
                    className="invoicePrint-SecondCustomerInfoTable"
                    data-test-selector="invoicePrint-SecondCustomerInfoTable"
                >
                    {/* second  table  first row */}
                    <GridItem className="customerInfoGridItem" {...styles.customerInfoGridItem}>
                        <StyledWrapper
                            className="customerInfoWrapperFirstRowSecondTable"
                            {...styles.customerInfoWrapperFirstRowSecondTable}
                        >
                            <GridItem className="writerGridItem" {...styles.writerGridItem}>
                                <Typography>{translate("WRITER")}</Typography>
                            </GridItem>
                            <GridItem className="shipViaNumberGridItem" {...styles.shipViaNumberGridItem}>
                                <Typography>{translate("SHIP VIA")}</Typography>
                            </GridItem>
                            <GridItem className="termsGridItem" {...styles.termsGridItem}>
                                <Typography>{translate("TERMS")}</Typography>
                            </GridItem>
                            <GridItem className="shipDateGridItem" {...styles.shipDateGridItem}>
                                <Typography>{translate("SHIP DATE")}</Typography>
                            </GridItem>
                            <GridItem className="orderDateGridItem" {...styles.orderDateGridItem}>
                                <Typography>{translate("ORDER DATE")}</Typography>
                            </GridItem>
                        </StyledWrapper>
                        {/* second Table Second Row */}
                        <StyledWrapper
                            className="customerInfoWrapperSecondrRow"
                            {...styles.customerInfoWrapperSecondrRow}
                        >
                            <GridItem className="writerGridItem" {...styles.writerGridItem}>
                                <Typography className="description" {...styles.description}>
                                    {invoice.properties?.writer}
                                </Typography>
                            </GridItem>
                            <GridItem className="shipViaNumberGridItem" {...styles.shipViaNumberGridItem}>
                                {invoice.shipViaDescription || invoice.properties?.shipCode}
                            </GridItem>
                            <GridItem className="termsGridItem" {...styles.termsGridItem}>
                                <Typography className="description" {...styles.description}>
                                    {invoice.terms}
                                </Typography>
                            </GridItem>
                            <StyledWrapper style={{ width: "20%", textAlign: "center" }}>
                                <>
                                    <GridItem className="shipDateGridItem" {...styles.shipDateGridItem}>
                                        <Typography className="shipDateGridItemValue" {...styles.description}>
                                            {getLocalizedDateTime({
                                                dateTime: new Date(invoice.invoiceDate),
                                                language,
                                            })}
                                        </Typography>
                                    </GridItem>
                                </>
                            </StyledWrapper>
                            <StyledWrapper style={{ width: "20%", textAlign: "center" }}>
                                <GridItem className="orderDateGridItemValue" {...styles.orderDateGridItem}>
                                    {getLocalizedDateTime({
                                        dateTime: new Date(invoice.properties?.orderDate),
                                        language,
                                    })}
                                </GridItem>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                </StyledWrapper>

                {/* Third Description table */}
                <StyledWrapper style={{ marginTop: "10px" }}>
                    <DataTable className="invoice-line-table" style={{ border: "solid" }}>
                        <DataTableHead style={{ background: "#b4b0b0", border: "solid", textTransform: "uppercase" }}>
                            <DataTableHeader
                                className="invoice-line-discription"
                                style={{
                                    fontSize: "15px",
                                    verticalAlign: "top",
                                    width: "60%",
                                    textAlign: "initial",
                                    background: "#b4b0b0",
                                    border: "solid",
                                }}
                            >
                                {translate("DESCRIPTION")}
                            </DataTableHeader>
                            <DataTableHeader
                                className="invoice-line-qty-ordered"
                                style={{
                                    fontSize: "15px",
                                    textAlign: "center",
                                    verticalAlign: "top",
                                    width: "10%",
                                    background: "#b4b0b0",
                                    border: "solid",
                                }}
                            >
                                {translate("QTY ORDERED")}
                            </DataTableHeader>
                            <DataTableHeader
                                className="invoice-line-shipped"
                                style={{
                                    fontSize: "15px",
                                    textAlign: "center",
                                    verticalAlign: "top",
                                    width: "10%",
                                    background: "#b4b0b0",
                                    border: "solid",
                                }}
                            >
                                {translate("QTY SHIPPED")}
                            </DataTableHeader>
                            <DataTableHeader
                                className="invoice-line-unitprice"
                                style={{
                                    fontSize: "15px",
                                    textAlign: "center",
                                    verticalAlign: "top",
                                    width: "10%",
                                    background: "#b4b0b0",
                                    border: "solid",
                                }}
                            >
                                {translate("PRICE")}
                            </DataTableHeader>
                            <DataTableHeader
                                className="invoice-line-extended"
                                style={{
                                    fontSize: "15px",
                                    textAlign: "center",
                                    verticalAlign: "top",
                                    width: "10%",
                                    background: "#b4b0b0",
                                    border: "solid",
                                }}
                            >
                                {translate("EXT PRICE")}
                            </DataTableHeader>
                        </DataTableHead>
                        <DataTableBody>
                            {invoice.invoiceLines.map(invoiceLine => (
                                <DataTableRow key={invoiceLine.id}>
                                    <DataTableCell
                                        style={{
                                            fontSize: "15px",
                                            verticalAlign: "top",
                                            width: "60%",
                                            display: "grid",
                                            paddingBottom: "5px",
                                            textAlign: "initial",
                                        }}
                                    >
                                        <Typography className="desc"> {invoiceLine.description}</Typography>
                                        <GridItem className="item-mfg-Grid">
                                            <Typography className="item" {...styles.description}>
                                                ITEM #{invoiceLine.productERPNumber}
                                            </Typography>
                                            <Typography className="mfg" {...styles.description}>
                                                MFG #{invoiceLine.manufacturerItem}
                                            </Typography>
                                        </GridItem>
                                    </DataTableCell>
                                    <DataTableCell
                                        style={{
                                            fontSize: "15px",
                                            textAlign: "center",
                                            verticalAlign: "top",
                                            width: "10%",
                                            paddingBottom: "5px",
                                        }}
                                    >
                                        {invoiceLine.qtyInvoiced}
                                    </DataTableCell>
                                    <DataTableCell
                                        style={{
                                            fontSize: "15px",
                                            textAlign: "center",
                                            verticalAlign: "top",
                                            width: "10%",
                                            paddingBottom: "5px",
                                        }}
                                    >
                                        {invoiceLine.qtyInvoiced}
                                    </DataTableCell>
                                    <DataTableCell
                                        style={{
                                            fontSize: "15px",
                                            textAlign: "center",
                                            verticalAlign: "top",
                                            width: "10%",
                                            paddingBottom: "5px",
                                            textTransform: "uppercase",
                                        }}
                                    >
                                        {invoiceLine.unitPriceDisplay}/{invoiceLine.unitOfMeasure}
                                    </DataTableCell>
                                    <DataTableCell
                                        style={{
                                            fontSize: "15px",
                                            textAlign: "right",
                                            verticalAlign: "top",
                                            width: "10%",
                                            paddingBottom: "5px",
                                        }}
                                    >
                                        {invoiceLine.lineTotalDisplay}
                                    </DataTableCell>
                                </DataTableRow>
                            ))}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
                <StyledWrapper
                    className="msgTotalWrapper"
                    {...styles.msgTotalWrapper}
                    data-test-selector="invoicePrint-messageConatiner"
                >
                    {/* Invoice Details  Message container */}
                    <StyledWrapper className="messageWrapper" {...styles.messageWrapper}>
                        <GridItem className="messageGridItem" {...styles.messageGridItem}>
                            <Typography className="msgText1" {...styles.msgText1}>
                                {translate(
                                    "All claims for  shortage  or errors must be made at once. Returns require written authorization and are subject to handling changres. Special orders are non-returnable.",
                                )}
                            </Typography>
                            <Typography className="msgText2" {...styles.msgText2}>
                                {translate("Past due invoices may be subject to late charges.")}
                            </Typography>
                        </GridItem>
                    </StyledWrapper>
                    {/* Invoice Details Total container */}
                    <StyledWrapper
                        style={{ display: "flex", justifyContent: "end" }}
                        className="totalContainer"
                        {...styles.totalContainer}
                        data-test-selector="invoicePtint_total"
                    >
                        <StyledWrapper className="invoice-footer-tax-container">
                            <GridItem className="invoice-footer-tax-column" {...styles.labelGridItem}>
                                <Typography variant="h5" {...styles.subtotalLabelText}>
                                    {translate("SUBTOTAL") + (enableVat ? ` (${translate("Ex. VAT")})` : "")}
                                </Typography>
                                <Typography variant="p" {...styles.subtotalValueText}>
                                    {invoice.productTotalDisplay}
                                </Typography>
                            </GridItem>
                            {invoice.discountAmount > 0 && (
                                <>
                                    <GridItem className="invoice-footer-tax-column" {...styles.labelGridItem}>
                                        <Typography variant="h5" {...styles.discountsLabelText}>
                                            {translate("DISCOUNTS")}
                                        </Typography>
                                        <Typography variant="p" {...styles.discountsValueText}>
                                            {invoice.discountAmountDisplay}
                                        </Typography>
                                    </GridItem>
                                </>
                            )}
                            {invoice.shippingAndHandling > 0 && (
                                <>
                                    <GridItem className="invoice-footer-tax-column" {...styles.labelGridItem}>
                                        <Typography variant="h5" {...styles.shippingAndHandlingLabelText}>
                                            {translate("S&H CHGS")}
                                        </Typography>
                                        <Typography variant="p" {...styles.shippingAndHandlingValueText}>
                                            {invoice.shippingAndHandlingDisplay}
                                        </Typography>
                                    </GridItem>
                                </>
                            )}
                            {invoice.otherCharges > 0 && (
                                <>
                                    <GridItem className="invoice-footer-tax-column" {...styles.labelGridItem}>
                                        <Typography variant="h5" {...styles.otherChargesLabelText}>
                                            {translate("OTHER CHARGES")}
                                        </Typography>
                                        <Typography variant="p" {...styles.otherChargesValueText}>
                                            {invoice.otherChargesDisplay}
                                        </Typography>
                                    </GridItem>
                                </>
                            )}
                            {(!invoice.invoiceHistoryTaxes || invoice.invoiceHistoryTaxes.length === 0) && (
                                <>
                                    <GridItem className="invoice-footer-tax-column" {...styles.labelGridItem}>
                                        <Typography variant="h5" {...styles.taxLabelText}>
                                            {enableVat ? translate("VAT") : translate("TAX")}
                                        </Typography>
                                        <Typography variant="p" {...styles.taxValueText}>
                                            {invoice.taxAmountDisplay}
                                        </Typography>
                                    </GridItem>
                                </>
                            )}
                            {invoice.invoiceHistoryTaxes &&
                                invoice
                                    .invoiceHistoryTaxes!.sort(tax => tax.sortOrder)
                                    .map(tax => {
                                        const key = `${tax.taxCode}_${tax.sortOrder}`;
                                        return (
                                            <React.Fragment key={key}>
                                                <GridItem
                                                    className="invoice-footer-tax-column"
                                                    {...styles.labelGridItem}
                                                >
                                                    <Typography variant="h5">
                                                        {tax.taxDescription || translate("TAXES")}
                                                    </Typography>
                                                    <Typography variant="p" {...styles.taxValueText}>
                                                        {tax.taxAmountDisplay}
                                                    </Typography>
                                                </GridItem>
                                            </React.Fragment>
                                        );
                                    })}
                            <GridItem className="invoice-footer-tax-column" {...styles.labelGridItem}>
                                <Typography variant="h4" {...styles.totalLabelText}>
                                    {translate("TOTAL")}
                                </Typography>
                                <Typography variant="p" className="totalValueText" {...styles.totalValueText}>
                                    {invoice.invoiceTotalDisplay}
                                </Typography>
                            </GridItem>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>

                {/* Invoice deatails signature table */}
                {invoice.properties["signature"] && (
                    <GridContainer
                        className="signatureContainer"
                        {...styles.signatureContainer}
                        data-test-selector="invoicePrint-DeliverySignatureContainer"
                    >
                        <Typography className="signatureText" {...styles.signatureText}>
                            {translate("DELIVERY CONFIRMATION")}
                        </Typography>
                        <StyledWrapper className="signatureWrapper" {...styles.signatureWrapper}>
                            <Typography className="titleText" {...styles.titleText}>
                                {translate("Delivery Confirmation Signature: ")}
                            </Typography>
                            <Typography className="description" {...styles.description}>
                                <img src={invoice.properties["signature"]} alt="" />
                            </Typography>{" "}
                        </StyledWrapper>
                    </GridContainer>
                )}
                {/* Invoice Details shipment package */}

                <StyledWrapper className="tableWrapper" {...styles.tableWrapper}>
                    <DataTable>
                        <DataTableBody {...styles.dataTableBody}>
                            {(shipmentObj && shipmentObj.ShipmentPackages !== undefined) || null
                                ? shipmentObj.ShipmentPackages.map(
                                      (shipmentPackage: {
                                          Id: string | undefined;
                                          ShipmentDate: string | Date;
                                          Carrier: string;
                                          ShipVia: string;
                                          TrackingUrl: string;
                                      }) => (
                                          <>
                                              <StyledWrapper
                                                  style={{
                                                      textAlign: "initial",
                                                      fontSize: "20px",
                                                      fontWeight: "bold",
                                                      padding: "20px",
                                                  }}
                                              >
                                                  {translate("Tracking Information")}
                                              </StyledWrapper>
                                              <DataTable
                                                  className="dataTable"
                                                  style={{ borderRight: "black", width: "70%", background: "#f2f2f2" }}
                                              >
                                                  <DataTableHead {...styles.dataTableHead}>
                                                      <DataTableHeader style={{ padding: "10px" }}>
                                                          {translate("Ship Date")}
                                                      </DataTableHeader>
                                                      <DataTableHeader style={{ padding: "10px" }}>
                                                          {translate("Carrier")}
                                                      </DataTableHeader>
                                                      <DataTableHeader style={{ padding: "10px" }}>
                                                          {translate("Service")}
                                                      </DataTableHeader>
                                                      <DataTableHeader style={{ padding: "10px" }}>
                                                          {translate("Tracking #")}
                                                      </DataTableHeader>
                                                  </DataTableHead>
                                                  <DataTableRow
                                                      className="dataTableRow"
                                                      {...styles.dataTableRow}
                                                      key={shipmentPackage.Id}
                                                      style={{ textAlign: "center" }}
                                                  >
                                                      <DataTableCell style={{ padding: "5px" }}>
                                                          <LocalizedDateTime
                                                              dateTime={new Date(shipmentPackage.ShipmentDate)}
                                                              options={{
                                                                  year: "numeric",
                                                                  month: "numeric",
                                                                  day: "numeric",
                                                              }}
                                                          />
                                                      </DataTableCell>
                                                      <DataTableCell style={{ padding: "5px" }}>
                                                          {shipmentPackage.Carrier}
                                                      </DataTableCell>
                                                      <DataTableCell style={{ padding: "5px" }}>
                                                          {shipmentPackage.ShipVia}
                                                      </DataTableCell>
                                                      <DataTableCell style={{ padding: "5px" }}>
                                                          {parse(shipmentPackage.TrackingUrl, parserOptions)}
                                                      </DataTableCell>
                                                  </DataTableRow>
                                              </DataTable>
                                          </>
                                      ),
                                  )
                                : null}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
            </StyledWrapper>
            <Zone contentId="" zoneName="Content1" />
        </>
    );
};

export default InvoiceHistoryPrintComponent;
